export const formatCurrency = (amount, currency = 'KES') =>
  new Intl.NumberFormat('en-KE', { style: 'currency', currency, minimumFractionDigits: 0 }).format(amount || 0);

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-KE', { day: '2-digit', month: 'short', year: 'numeric' });

export const formatDateTime = (dateStr) =>
  new Date(dateStr).toLocaleString('en-KE', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const formatNumber = (n) =>
  new Intl.NumberFormat('en-KE').format(n || 0);

export const getInitials = (name = '') =>
  name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);

export const truncate = (str, max = 40) =>
  str?.length > max ? str.slice(0, max) + '…' : str;